// en_pms_channel_manager.ts
// Tłumaczenia dla PMS.ChannelManager.tsx

export const enPmsChannelManager = {

  title: "Channel Manager",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    syncControl:  "Sync control",
    connections:  "Connections",
    recentSync:   "Recent sync attempts",
    importLinks:  "Imported links",
  },

  // ── Opisy ────────────────────────────────────────────────────────────────
  descriptions: {
    neutral:         "OTA distribution without vendor binding, reservation import, inventory protection and sync monitoring.",
    pushRates:       "Push rates and availability with idempotent request keys.",
    providerStatus:  "Provider status and error visibility.",
    rateRows:        "Rate and inventory rows prepared for the selected period.",
    syncHistory:     "Sync history and retry-safe errors.",
    externalIds:     "External channel IDs linked to PMS reservations.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    connection:         "Connection",
    connections:        "Connections",
    currentPushPayload: "Current push payload",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    importCompleted:"Reservation import completed.",
    importFailed:   "Reservation import failed.",
    syncFailed:     "Sync failed.",
  },

} as const;

export default enPmsChannelManager;
